<template>
  <b-card class="border-0">
    <h4><b-icon icon="envelope" class="mr-2"/><translate>Email Address</translate></h4>
    <ul>
      <li><b>Marius Mihut –</b> <a href="mailto:marius.mihut@marioviajes.com"><em>marius.mihut@marioviajes.com</em></a></li>
      <li><b>Cristina Dascalu –</b> <a href="mailto:office@marioviajes.com"><em>office@marioviajes.com</em></a></li>
      <li><b>Virag Merics –</b> <a href="mailto:reservas@marioviajes.com"><em>reservas@marioviajes.com</em></a></li>
      <li><b>Emma Stanescu –</b> <a href="mailto:reservas@marioviajes.com"><em>reservas@marioviajes.com</em></a></li>
    </ul>
  </b-card>
</template>

<script>
export default {
  name: 'emailAddress'
}
</script>

<style lang="scss" scoped>
  .modal-body h4 {
    font-size: 1.3rem;
    color: #293e97;
    border-bottom: 1px solid #ddd;
  }
</style>
